/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { adDesignDestroy } from '../../axios/adDesignDestroy'
import type {
	AdDesignDestroyError,
	AdDesignDestroyPathParams,
	AdDesignDestroyResponse,
} from '../../types/AdDesignDestroy'

export const adDesignDestroyMutationKey = () => [{ url: '/organisations/:organisation/ad-designs/:adDesign' }] as const

export type AdDesignDestroyMutationKey = ReturnType<typeof adDesignDestroyMutationKey>

export type AdDesignDestroyVariables = {
	organisation: AdDesignDestroyPathParams['organisation']
	adDesign: AdDesignDestroyPathParams['adDesign']
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::destroy */
export function useAdDesignDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		AdDesignDestroyResponse,
		AxiosError<AdDesignDestroyError>,
		AdDesignDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: adDesignDestroyMutationKey(),
		mutationFn: ({ organisation, adDesign }: AdDesignDestroyVariables) =>
			adDesignDestroy(organisation, adDesign, config).then(res => res.data),
		...options,
	})
}
